export interface UpdateExpiredPasswordInput {
  username: string;
  password: string;
  newPassword: string;
}

export enum UpdateExpiredPasswordStatus {
  UserNamePasswordError = "UserNamePasswordError",
  OnlyExpiredUserPassword = "OnlyExpiredUserPassword",
  UserLocked = "UserLocked",
}
